import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-mu-radio-icon',
  templateUrl: './mu-radio-icon.component.html',
  styleUrls: ['./mu-radio-icon.component.sass'],
})
export class MuRadioIconComponent implements OnInit {
  @Input() formData: UntypedFormGroup;
  @Input() label: string;
  @Input() skinIcon: boolean;
  @Input() controlName: string;
  @Input() column: number;
  @Input() columnMd: number;
  @Input() columnLg: number;
  @Input() colFlex: boolean;
  @Input() icon: string;
  @Input() value: any;
  @Input() hasPermission: boolean;
  @HostBinding('class') baseClass: string;
  @Input() showData: boolean;

  constructor() {
    /** */
  }

  ngOnInit(): void {
    const columnValue = this.column ? 12 : '';
    const colFlexValue = !this.colFlex ? columnValue : this.column;
    this.baseClass = 'p-col-' + colFlexValue + ' p-md-' + this.columnMd + ' p-lg-' + this.columnLg;
    this.baseClass += this.colFlex ? ' p-col' : '';
  }
}
